import React, { useEffect, useRef, useState } from "react";
import ReactDOM from "react-dom";
import "./TagColorPickerModal.css";
import TagComponent from "../TagsSuggestionDropdown/TagComponent";
import { tagColors } from "../../helpers/tagColors";

const TagColorPickerModal = ({
  isOpen,
  tag,
  currentColor,
  onSave,
  onClose,
}) => {
  const [color, setColor] = useState(currentColor || "#9D7BFF");
  const modalRef = useRef(null);

  useEffect(() => {
    setColor(currentColor || "#9D7BFF");
  }, [currentColor]);

  useEffect(() => {
    if (!isOpen) return;
    const handleKeyDown = (e) => {
      if (e.key === "Escape") onClose();
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [isOpen, onClose]);

  const handleSave = () => {
    onSave(tag.id, color);
    onClose();
  };

  const handlePaletteColor = (c) => {
    setColor(c);
  };

  if (!isOpen) return null;

  return ReactDOM.createPortal(
    <div className="tag-color-modal-overlay">
      <div className="tag-color-modal" ref={modalRef}>
        <button
          className="tag-color-modal-close"
          onClick={onClose}
          aria-label="Закрыть"
        >
          ✕
        </button>

        <h2 className="tag-color-modal-title">Настроить цвет тега</h2>
        <div className="tag-color-modal-preview">
          <TagComponent
            tag={{ ...tag, color }}
            color={color}
            tagsDefaultColors={{}}
            needCount={false}
          />
        </div>

        <div className="tag-color-modal-section">
          <label className="tag-color-modal-label">Текущий цвет</label>
          <div className="tag-color-modal-row">
            <input
              type="color"
              value={color}
              onChange={(e) => setColor(e.target.value)}
              className="tag-color-picker"
            />
            <span className="tag-color-modal-hex">{color}</span>
          </div>
        </div>

        <div className="tag-color-modal-section">
          <label className="tag-color-modal-label">Быстрый выбор</label>
          <div className="tag-color-palette">
            {tagColors.map((c) => (
              <button
                key={c}
                type="button"
                className={`tag-color-palette-item${
                  c === color ? " tag-color-palette-item--active" : ""
                }`}
                style={{ backgroundColor: c }}
                onClick={() => handlePaletteColor(c)}
              />
            ))}
          </div>
        </div>

        <div className="tag-color-modal-actions">
          <button
            type="button"
            className="tag-color-modal-btn tag-color-modal-btn--cancel"
            onClick={onClose}
          >
            Отмена
          </button>
          <button
            type="button"
            className="tag-color-modal-btn tag-color-modal-btn--save"
            onClick={handleSave}
          >
            Сохранить
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default TagColorPickerModal;
